import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MdbCheckboxModule, MdbFormsModule } from 'mdb5-adapted';

import { StyleConfigComponent } from './style-config.component';
import { StyleStateToggleComponent } from './style-state-toggle.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MdbFormsModule,
    FormsModule,
    MdbCheckboxModule
],
  declarations: [
    StyleConfigComponent,
    StyleStateToggleComponent,
  ],
  exports: [
  ],
  providers: []
})
export class LMSStyleConfigModule {

}
